import { render, staticRenderFns } from "./block-review-form.vue?vue&type=template&id=f1a6e7a2&scoped=true&lang=pug&"
import script from "./block-review-form.vue?vue&type=script&lang=js&"
export * from "./block-review-form.vue?vue&type=script&lang=js&"
import style0 from "./block-review-form.vue?vue&type=style&index=0&id=f1a6e7a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a6e7a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
